import moment from 'moment';
export const dealDateToTableData = ({ start, end, dateType }) => {
    let tableData = [];
    switch (dateType) {
        case 1:
            tableData = dealDay({ start, end });
            break;
        case 2:
            tableData = dealWeek({ start, end });
            break;
        case 3:
            tableData = dealMonth({ start, end });
            break;
        case 4:
            if (typeof start === 'object') {
                tableData = (start.year && end.year) && dealQuarter({ start, end });
            }
            else if (start && end) {
                tableData = dealQuarter({
                    start: {
                        year: moment(start).year(),
                        quarter: moment(start).quarter(),
                    },
                    end: {
                        year: moment(end).year(),
                        quarter: moment(end).quarter(),
                    },
                });
            }
            break;
    }
    return tableData;
};
const dealDay = ({ start, end }) => {
    const beginDate = moment(start);
    const endDate = moment(end);
    const tableData = [];
    const days = endDate.diff(start, 'days');
    const showRowLength = days + 1;
    const isOverMaxShow = showRowLength > 30;
    const loopNum = showRowLength > 30 ? 30 : showRowLength;
    let loopIndex = 0;
    while (loopIndex < loopNum) {
        tableData.push({
            startDt: beginDate.format('YYYY-MM-DD'),
        });
        beginDate.add(1, 'd');
        loopIndex += 1;
    }
    isOverMaxShow && tableData.push(...[
        {
            startDt: '...',
            isOver: 1,
        },
        {
            startDt: endDate.format('YYYY-MM-DD'),
        },
    ]);
    return tableData;
};
const dealWeek = ({ start, end }) => {
    const tableData = [];
    const startDateCopy = moment(start);
    const endDateCopy = moment(end);
    // 如果开始日期不为周日  则周一日期为 moment().day(1);
    // 如果开始日期为周日  则周一日期为 moment().day(-6);
    const beginIsSunday = startDateCopy.day() === 0;
    // 如果结束日期不为周日  则周日日期为 moment().day(7);
    // 如果结束日期为周日  则周日日期为 moment().day(0)
    const endIsSunday = endDateCopy.day() === 0;
    const beginDate = beginIsSunday ? startDateCopy.day(-6) : startDateCopy.day(1);
    const endDate = endIsSunday ? endDateCopy.day(-6) : endDateCopy.day(7);
    const weeks = endDate.diff(beginDate, 'weeks'); // +6 day d
    const showRowLength = weeks + 1;
    const isOverMaxShow = showRowLength > 30;
    const loopNum = showRowLength > 30 ? 30 : showRowLength;
    let loopIndex = 0;
    while (loopIndex < loopNum) {
        tableData.push({
            startDt: `${beginDate.format('YYYY-MM-DD')} ～ ${beginDate.add(6, 'd').format('YYYY-MM-DD')}`,
        });
        beginDate.add(1, 'd');
        loopIndex += 1;
    }
    isOverMaxShow && tableData.push(...[
        {
            startDt: '...',
            isOver: 1,
        },
        {
            startDt: `${moment(endDate).subtract(6, 'd').format('YYYY-MM-DD')} ～ ${endDate.format('YYYY-MM-DD')}`,
        },
    ]);
    return tableData;
};
const dealMonth = ({ start, end }) => {
    const tableData = [];
    const startDateCopy = moment(start);
    const endDateCopy = moment(end);
    const months = endDateCopy.diff(startDateCopy, 'months'); // +1 month M
    const showRowLength = months + 1;
    const beginDate = startDateCopy.startOf('month');
    const endDate = endDateCopy.endOf('month');
    const isOverMaxShow = showRowLength > 30;
    const loopNum = showRowLength > 30 ? 30 : showRowLength;
    let loopIndex = 0;
    while (loopIndex < loopNum) {
        tableData.push({
            startDt: beginDate.format('YYYY-MM'),
        });
        beginDate.add(1, 'M');
        loopIndex += 1;
    }
    isOverMaxShow && tableData.push(...[
        {
            startDt: '...',
            isOver: 1,
        },
        {
            startDt: endDate.format('YYYY-MM'),
        },
    ]);
    return tableData;
};
const dealQuarter = ({ start, end }) => {
    let startDateCopy;
    let endDateCopy;
    if (typeof start === 'string') {
        startDateCopy = {
            year: moment(start).year(),
            quarter: moment(start).quarter(),
        };
        endDateCopy = {
            year: moment(end).year(),
            quarter: moment(end).quarter(),
        };
    }
    else {
        startDateCopy = moment(`${start.year}`).quarter(start.quarter);
        endDateCopy = moment(`${end.year}`).quarter(end.quarter);
    }
    const tableData = [];
    const quarters = endDateCopy.diff(startDateCopy, 'quarters'); // +1 quarters Q
    const showRowLength = quarters + 1;
    const beginDate = startDateCopy.startOf('month');
    const endDate = endDateCopy.endOf('month');
    const isOverMaxShow = showRowLength > 30;
    const loopNum = showRowLength > 30 ? 30 : showRowLength;
    let loopIndex = 0;
    while (loopIndex < loopNum) {
        tableData.push({
            startDt: `${beginDate.year()} 第${beginDate.quarter()}季度`,
        });
        beginDate.add(1, 'Q');
        loopIndex += 1;
    }
    isOverMaxShow && tableData.push(...[
        {
            startDt: '...',
            isOver: 1,
        },
        {
            startDt: `${endDate.year()} 第${endDate.quarter()}季度`,
        },
    ]);
    return tableData;
};
